import React, { useState } from 'react';
import { SampleCheckinSheet } from '../../../services/ReportService';
import { NotificationManager } from 'react-notifications';
import DownloadAnchor from '../../common/DownloadAnchor';

const ViewSampleCheckinSheet = ({ orderNumber }) => {
  const [loading, setLoading] = useState(false);

  const fetchPdf = async () => {
    setLoading(true);
    try {      
      const pdfBytes = await SampleCheckinSheet(orderNumber);
      if (pdfBytes !== null) {
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        NotificationManager.success('Document is Downloaded', 'Success!');
      } else {
        NotificationManager.error('Error fetching PDF');
      }
    } catch (error) {
      console.error('Error fetching PDF:', error);
      NotificationManager.error('Error fetching PDF', error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <DownloadAnchor func={fetchPdf} loading={loading} />
    </div>
  );
};

export default ViewSampleCheckinSheet;
